import { Record } from "immutable";

const recordClassCreator = map => class extends Record(map) {
    
};

export default recordClassCreator;
